import type { LogsInitConfiguration } from '@datadog/browser-logs'
import type { RumInitConfiguration } from '@datadog/browser-rum'

import type { BackendKey } from './env'

const CLIENT_TOKEN = 'pub13634e6242ddf896c175cfd2d2f57b23'
const SITE = 'datadoghq.com'
const SERVICE = 'synop-next'

export default function getDatadogConfig(env: BackendKey, appVersion: string): RumInitConfiguration {
  return {
    applicationId: 'b3111eba-7bb2-4e72-8aad-8bef47e230e8',
    clientToken: CLIENT_TOKEN,
    site: SITE,
    service: SERVICE,
    env,

    // Specify a version number to identify the deployed version of your application in Datadog
    version: appVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    startSessionReplayRecordingManually: true
  }
}

export function getDatadogLogsConfig(env: BackendKey, appVersion: string): LogsInitConfiguration {
  return {
    clientToken: CLIENT_TOKEN,
    site: SITE,
    service: SERVICE,
    env,
    version: appVersion,
    // Uncaught exceptions are sent to Rollbar
    forwardErrorsToLogs: false,
    sessionSampleRate: 100
  }
}
